import { useRichText } from "@hooks/useRichText";
import { useRoutes } from "@hooks/useRoutes";
import { ComponentProps, FromSanityGraphQL } from "@ts/components";
import { SectionTitle } from "@ts/sanity";
import React, { FC } from "react";

type TitleInputProps = ComponentProps & FromSanityGraphQL<SectionTitle>;

type TitleOutputProps = Omit<TitleInputProps, "buttonLink"> & {
  buttonLink?: string;
  buttonTitle?: string;
};

export const withTitle =
  (Component: FC<TitleOutputProps>) =>
  ({ name = "Title", content, buttonLink, ...rest }: TitleInputProps) => {
    const { parseContent } = useRichText();
    const { linkResolver } = useRoutes();
    const normalisedContent = parseContent(content);
    const button = linkResolver(buttonLink);

    Component.displayName = name;

    return (
      <Component
        buttonTitle={button?.title}
        buttonLink={button?.url}
        content={normalisedContent}
        {...rest}
      />
    );
  };
